import React from 'react';
import { LinkToCommonLogin } from '../../components/index';
import { UnifiedLayout } from '../../layouts/UnifiedLayout/UnifiedLayout';
import { Header } from '@solarwindscloud/nighthawk-ui';

export const dataTestIds = {
  messagePage: 'message-page',
  linkToSignup: 'link-to-signup',
};

const MessagePage = ({ message, dataTestPageName }) => {
  return (
    <UnifiedLayout headerText={message} dataTestId={dataTestIds.messagePage} dataTestPageName={dataTestPageName}>
      <Header textAlign="center">
        <Header.Subheader>
          <LinkToCommonLogin>Continue to Login</LinkToCommonLogin>
        </Header.Subheader>
      </Header>
    </UnifiedLayout>
  );
};

export default MessagePage;
